export const clientThemes: Record<string, Record<string, string>> = {
  BibbyMarine: {
    "--login-bg": "#000000",
    "--login-h2-color": "#ffffff",
    "--login-header-color": "#ffffff",
    "--login-primary-button-color": "#000000",
    "--primary-color": "#000000",
    "--custom-primary-color": "#1a1a1a",
    "--link-color": "#333333",
    "--border-color-base": "#000000",
    "--background-color": "#f5f5f5",
    "--error-color": "#d6222b",
    "--warning-color": "#fa8c16",
    "--success-color": "#52c41a",
    "--highlight-color": "#000000",
    "--primary-1": "#e8e8e8",
    "--primary-5": "#595959",
    "--primary-6": "#000000",
    "--warn-color": "#fa8c16",
    "--warn-5": "#ffb84d",
    "--background-color-base": "#f0f0f0",
    "--label-color": "rgba(0, 0, 0, 0.75)",
    "--heading-5-size": "16px",
    "--font-family": "Arial",
  },
  SGS: {
    "--login-bg": "#ffffff",
    "--login-h2-color": "#ff6600",
    "--login-public-header-color": "#ff6600",
    "--login-primary-button-color": "#ff6600",
    "--primary-color": "#ff6600",
    "--custom-primary-color": "#3c505a", //for table header background
    "--link-color": "#ff8533",
    "--border-color-base": "#ff6600",
    "--background-color": "#fff5eb",
    "--error-color": "#d6222b",
    "--warning-color": "#fa8c16",
    "--success-color": "#52c41a",
    "--highlight-color": "#ff6600",
    "--primary-1": "#fff0e6", // very light
    "--primary-5": "#ff944d", // medium
    "--primary-6": "#ff6600", // base
    "--warn-color": "#fa8c16",
    "--warn-5": "#ffb84d",
    "--background-color-base": "#fff2e6",
    "--label-color": "rgba(0, 0, 0, 0.75)",
    "--heading-5-size": "16px",
    "--font-family": "Arial",
  },
};
